import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AuthWebModule } from '@vsolv/core/auth/web';
import { UsersWebModule } from '@vsolv/core/users/web';
import { ContentCardModule } from '@vsolv/ui-kit/card';
import { ModalModule } from '@vsolv/ui-kit/modal';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { AlertModule } from '@vsolv/vectors-ui/alert';
import { ButtonModule } from '@vsolv/vectors-ui/button';
import { DividerModule } from '@vsolv/vectors-ui/divider';
import { FormsModule } from '@vsolv/vectors-ui/forms';
import { InputModule } from '@vsolv/vectors-ui/input';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { SignInFormComponent, UserSecurityFormComponent } from './components';
import { SignOutButtonComponent } from './components/sign-out-button/sign-out-button.component';
import { FirebaseInterceptor } from './interceptors';
import { SendEmailModalComponent } from './modals';
import { FirebaseService } from './services';
import { FIREBASE_APP, FIREBASE_AUTH, FIREBASE_OPTIONS } from './tokens';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatTabsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSnackBarModule,

    AuthWebModule,
    UsersWebModule,
    ModalModule,
    ContentCardModule,
    OverlayModule,
    UtilsModule,
    // ToastModule,
    MatTooltipModule,
    FormsModule,
    InputModule,
    ButtonModule,
    ThemingModule,
    DividerModule,
    AlertModule,
    ButtonModule,
  ],
  providers: [FirebaseService],
  declarations: [SendEmailModalComponent, SignOutButtonComponent, SignInFormComponent, UserSecurityFormComponent],
  exports: [SignOutButtonComponent, SignInFormComponent, UserSecurityFormComponent, SendEmailModalComponent],
})
export class FirebaseWebModule {
  static forRoot(firebaseOptions: FirebaseOptions): ModuleWithProviders<FirebaseWebModule> {
    return {
      ngModule: FirebaseWebModule,
      providers: [
        { provide: FIREBASE_OPTIONS, useValue: firebaseOptions },
        {
          provide: FIREBASE_APP,
          useFactory: (options: FirebaseOptions) => (getApps().length ? getApp() : initializeApp(options)),
          deps: [FIREBASE_OPTIONS],
        },
        {
          provide: FIREBASE_AUTH,
          useFactory: (firebaseApp: FirebaseApp) => getAuth(firebaseApp),
          deps: [FIREBASE_APP],
        },
        { provide: HTTP_INTERCEPTORS, useClass: FirebaseInterceptor, multi: true },
      ],
    };
  }
}
